import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import Link from 'shared/components/Link';
import { toLocalized } from 'shared/helpers/locale';
import { compareByTitle } from 'shared/helpers/arrays';
import * as formActions from 'shared/actions/searchForm';
import types from 'shared/constants/json/transportTypes.json';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import { generateSearchQuery, generateSearchUrl } from 'shared/helpers/urls';
import BrandsColumn from 'desktop/components/BrandsList/BrandsColumn/BrandsColumn';

import s from './BrandsSearch.css';

class BrandsSearch extends Component {
  static propTypes = {
    makes: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        count: PropTypes.number,
      }),
    ).isRequired,
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape(),
    subHeadline: PropTypes.shape(),
    routeLocation: PropTypes.shape(),
    transportSlug: PropTypes.string,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    routeLocation: null,
    subHeadline: null,
    location: null,
    transportSlug: 'avto',
  };

  state = {
    collapsed: true,
  };

  componentDidMount = () => {
    const transportType = types.find(item => item.slug === this.props.transportSlug);
    this.props.selectedActions.set.transport(transportType);
  };

  setExpanded = collapsed => {
    this.setState({ collapsed });
  };

  buildBrandLink = slug => {
    const { routeLocation, location, transportSlug } = this.props;

    if (routeLocation && routeLocation.slug) {
      return `/${transportSlug}/${slug}/${routeLocation.slug}/`;
    } else if (location && location.slug) {
      return `/${transportSlug}/${slug}/${location.slug}/`;
    }

    return `/${transportSlug}/${slug}/`;
  };

  createColumns = (arr, columnCount) => {
    const step = Math.round(arr.length / columnCount);
    const biggestColumnCount = step === 0 && arr.length > 0 ? arr.length % columnCount : 0;

    const columns = Array.from(new Array(columnCount), (x, i) => i).map(item =>
      arr.slice(item * step, (item + 1) * step),
    );

    if (biggestColumnCount) {
      arr.slice(-biggestColumnCount).forEach((item, i) => columns[i].push(item));
    }

    return columns;
  };

  render() {
    const { makes, formState, formData, selectedActions, locale, intl } = this.props;
    const { models } = formData;
    const selectedSetActions = selectedActions.set;
    const brands =
      makes &&
      makes.map(brand => ({
        ...brand,
        link: this.buildBrandLink(brand.slug),
      }));

    const { collapsed } = this.state;
    const perColumn = 6;
    const columnsNum = 5;
    const columnWidth = {
      width: `${100 / columnsNum}%`,
    };

    let showedBrands = brands || [];

    if (collapsed) {
      showedBrands = showedBrands
        .slice()
        .sort((a, b) => -(parseFloat(a.count) - parseFloat(b.count)));

      showedBrands = showedBrands.slice(0, perColumn * columnsNum - 1);
      showedBrands = showedBrands.slice().sort(compareByTitle);
    }

    showedBrands = showedBrands.sort(compareByTitle);

    const pricePlaceholder = `${intl.formatMessage({ id: 'Цена от' })}, ${(formState.currency &&
      formState.currency.title) ||
      intl.formatMessage({ id: 'грн' })}`;

    if (makes) {
      makes.sort(compareByTitle);
    }

    const pathname = generateSearchUrl(formState);
    const query = generateSearchQuery(formState);

    const shouldShowBtn = brands && brands.length && brands.length > perColumn * columnsNum - 1;

    const columns = this.createColumns(showedBrands, columnsNum);

    return (
      <div className={s.root}>
        <div className={s.card}>
          <div className={s.searchForm}>
            <div className={s.col}>
              <Select
                placeholder={intl.formatMessage({ id: 'Марка' })}
                instanceId="make-ff"
                name="make"
                options={makes}
                labelKey="title"
                valueKey="id"
                onChange={selectedSetActions.make}
                value={formState.make}
                matchPos="start"
              />
            </div>

            <div className={s.col}>
              <Select
                instanceId="model-ff"
                name="model"
                placeholder={intl.formatMessage({ id: 'Модель' })}
                labelKey="title"
                valueKey="id"
                disabled={!models || !models.length}
                options={models}
                onChange={selectedSetActions.model}
                value={formState.model}
                matchPos="start"
              />
            </div>
            <div className={s.col}>
              <RegexpInput
                className={s.input}
                type="text"
                placeholder={intl.formatMessage({ id: 'Год, от' })}
                value={formState.yearFrom || ''}
                onChange={selectedSetActions.yearFrom}
                pattern={'^[0-9]+$'}
              />
            </div>
            <div className={s.col}>
              <RegexpInput
                className={s.input}
                type="text"
                placeholder={pricePlaceholder}
                value={formState.priceFrom || ''}
                onChange={selectedSetActions.priceFrom}
                pattern={'^[0-9]+$'}
              />
            </div>
            <Link
              rel="nofollow"
              to={toLocalized(`/${pathname}?${queryString.stringify(query)}`, locale)}
              className={s.find}
              data-lens-event={'searchClick'}
            >
              <FormattedMessage id="Найти" />
            </Link>
          </div>
          {this.props.subHeadline &&
            <h2 className={s.subHeadline}>
              {this.props.subHeadline}
            </h2>}
          {makes &&
            makes.length > 0 &&
            <div className={s.flexContainer}>
              {columns.map((items, i) =>
                // eslint-disable-next-line react/no-array-index-key
                <div className={s.column} style={columnWidth} key={i}>
                  <BrandsColumn
                    collapsed={collapsed}
                    isLast={i !== columnsNum - 1}
                    handleClick={this.setExpanded}
                    brands={items}
                    shouldShowBtn={shouldShowBtn}
                    onMakeChange={selectedSetActions.make}
                  />
                </div>,
              )}
            </div>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals }) => ({
  formState: searchForm && searchForm.selected,
  formData: searchForm && searchForm.data,
  locale: globals.locale,
  location: globals.location,
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...formActions.carSetThunks,
      },
      dispatch,
    ),
  },
});

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(BrandsSearch)),
);



// WEBPACK FOOTER //
// ./src/desktop/components/BrandsSearch/BrandsSearch.js